import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum VerveCoffeePickTicketLineItemKeys {
  qty = 'qty',
  description = 'description',
}

export const verveCoffeePickTicketAddressSchema = yup.object().shape({
  addressLine1: yup.string().nullable().optional(),
  addressLine2: yup.string().nullable().optional(),
  city: yup.string().nullable().optional(),
  state: yup.string().nullable().optional(),
  postalCode: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
})
export type VerveCoffeePickTicketAddress = yup.InferType<typeof verveCoffeePickTicketAddressSchema>

export const verveCoffeePickTicketFileDataSchema = yup.object().shape({
  shipTo: yup.object().shape({
    name: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: verveCoffeePickTicketAddressSchema.nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  buyerName: yup.string().nullable().optional(),
  buyerId: yup.string().nullable().optional(),
  giftMessage: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        [VerveCoffeePickTicketLineItemKeys.qty]: yup.string().nullable().optional(),
        [VerveCoffeePickTicketLineItemKeys.description]: yup.string().nullable().optional(),
      }),
    )
    .required(),
  organizationLogoOverride: yup.string().nullable().optional(),
})

export type VerveCoffeePickTicketFileData = yup.InferType<
  typeof verveCoffeePickTicketFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<VerveCoffeePickTicketFileData>

export const verveCoffeePickTicketFileMappings: RequiredFileData = {
  shipTo: {
    name: 'a1b2c3d4-e5f6-4789-8abc-def123456789',
    companyName: 'b2c3d4e5-f6a7-4b01-9cde-f12345678901',
    address: {
      addressLine1: 'c3d4e5f6-a7b8-4c12-ade1-234567890123',
      addressLine2: 'd4e5f6a7-b8c9-4d23-bef2-345678901234',
      city: 'e5f6a7b8-c9d0-4e34-8f12-456789012345',
      state: 'f6a7b8c9-d0e1-4f45-8a23-567890123456',
      postalCode: 'a7b8c9d0-e1f2-4a56-9b34-678901234567',
      country: 'b8c9d0e1-f2a3-4b67-8c45-789012345678',
    },
  },
  orderNumber: 'c9d0e1f2-a3b4-4c78-9d56-890123456789',
  date: 'd0e1f2a3-b4c5-4d89-8e67-901234567890',
  buyerName: 'e1f2a3b4-c5d6-4e90-9f78-012345678901',
  buyerId: 'f2a3b4c5-d6e7-4f01-8a89-123456789012',
  giftMessage: 'b4c5d6e7-f8a9-4b23-9c90-234567890123',
  items: [
    {
      qty: 'f8a9b0c1-d2e3-4f67-8a01-345678901234',
      description: 'a3b4c5d6-e7f8-4a12-9b23-456789012345',
    },
  ],
  organizationLogoOverride: 'e7f8a9b0-c1d2-4e56-9c45-567890123456',
}
